import {Injectable} from '@angular/core';
import {
  BehaviorSubject,
  Subject,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalLoaderService {

  public globalLoadingSubject: Subject<boolean> = new Subject<boolean>();

  public globalLoaderSuppressedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Updates the global loading state.
   * @param {boolean} loading - A boolean indicating whether the global loading state is active (true)
   * or inactive (false).
   * @return {void} Does not return a value.
   */
  public setGlobalLoading(loading: boolean): void {
    this.globalLoadingSubject.next(loading);
  }

  /**
   * Sets the global loader suppression state.
   * @param suppressed Determines whether the global loader should be suppressed.
   *                   A value of `true` suppresses the loader, while `false` allows it to be displayed.
   * @return void
   */
  public setGlobalLoaderSuppressed(suppressed: boolean): void {
    this.globalLoaderSuppressedSubject.next(suppressed);
  }

}
